import { Link } from "react-router-dom";
import modernAduImage from "@/assets/modern-adu-design-bay-area.png";
import zoningImage from "@/assets/what-can-you-build-adu-zoning.png";
import farmhouseImage from "@/assets/modern-farmhouse-adu-popular.png";
import designBuildImage from "@/assets/adu-design-build-process.png";
import smallAduImage from "@/assets/small-adu-feel-bigger.png";
import backyardImage from "@/assets/backyard-usable-living-space.png";
import rentalIncomeImage from "@/assets/adu-rental-income-california.png";
import fasterPermitsImage from "@/assets/simple-adus-faster-permits.png";
import flatRoofImage from "@/assets/modern-adu-flat-roof-design.png";
import fullServiceImage from "@/assets/full-service-adu-solutions.png";
import optimizingSmallImage from "@/assets/optimizing-small-adu-spaces.png";
import customMatchImage from "@/assets/custom-adus-match-your-home.png";
import propertyValueImage from "@/assets/investing-in-adus-property-value.png";
import privacyComfortImage from "@/assets/adu-privacy-comfort-design.png";
import indoorOutdoorImage from "@/assets/indoor-outdoor-adu-living.png";

const blogs = [
  { slug: "modern-adu-design-bay-area", title: "Modern ADU Design in the Bay Area", image: modernAduImage },
  { slug: "adu-zoning-explained", title: "ADU Zoning Explained", image: zoningImage },
  { slug: "modern-farmhouse-adus-popular", title: "Why Modern Farmhouse ADUs Are Popular", image: farmhouseImage },
  { slug: "adu-design-build-process", title: "ADU Design Build Process", image: designBuildImage },
  { slug: "small-adu-feel-bigger", title: "Make a Small ADU Feel Bigger", image: smallAduImage },
  { slug: "backyard-usable-living-space", title: "Backyard Into Living Space", image: backyardImage },
  { slug: "adu-rental-income-california", title: "ADU Rental Income in California", image: rentalIncomeImage },
  { slug: "simple-adus-faster-permits", title: "Simple ADUs, Faster Permits", image: fasterPermitsImage },
  { slug: "modern-adu-flat-roof-design", title: "Modern Flat Roof ADUs", image: flatRoofImage },
  { slug: "full-service-adu-solutions", title: "Full Service ADU Solutions", image: fullServiceImage },
  { slug: "optimizing-small-adu-spaces", title: "Optimizing Small ADU Spaces", image: optimizingSmallImage },
  { slug: "custom-adus-match-your-home", title: "Custom ADUs That Match Your Home", image: customMatchImage },
  { slug: "investing-in-adus-property-value", title: "ADUs Amplify Property Value", image: propertyValueImage },
  { slug: "adu-privacy-comfort-design", title: "ADUs for Privacy & Comfort", image: privacyComfortImage },
  { slug: "indoor-outdoor-adu-living", title: "Indoor Outdoor ADU Living", image: indoorOutdoorImage },
];

const BlogCarouselStrip = ({ isDark = false }: { isDark?: boolean }) => {
  // Duplicate for seamless loop
  const items = [...blogs, ...blogs];

  return (
    <div className="w-full py-3 overflow-hidden">
      <h3 className="text-center mb-2 text-4xl font-normal" style={{ color: "#E4683B" }}>
        From Our Blog
      </h3>
      <div className="relative overflow-hidden">
        <div className="flex gap-3 animate-scroll-left w-max">
          {items.map((blog, i) => (
            <Link
              key={`${blog.slug}-${i}`}
              to={`/blogs/${blog.slug}`}
              className={`flex-shrink-0 w-64 rounded-lg overflow-hidden transition-transform duration-200 hover:scale-105 ${
                isDark
                  ? "bg-[#161616] shadow-[2px_2px_6px_#000,-2px_-2px_6px_#1a1a1a]"
                  : "bg-[#f5f5f5] shadow-[2px_2px_6px_#d8d8d8,-2px_-2px_6px_#fefefe]"
              }`}
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-36 object-cover"
              />
              <p
                className={`text-xs leading-tight font-medium p-2 line-clamp-2 ${
                  isDark ? "text-gray-300" : "text-gray-700"
                }`}
              >
                {blog.title}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogCarouselStrip;
